// @flow
import { ACTIONS } from '../actions';

export const metaTree = (
    state: {} = {
        categories: {},
        instances: {}
    },
    action: { type: string, meta: {} }
): {} => {
    switch (action.type) {
        case ACTIONS.INITIALIZE_META:
            return { ...action.metaTree };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/state/reducer/analytics/reducers/metaTree.js